import React from 'react';
import SABadge from '../../components/SuperAdmin/SABadge';
import '../../assets/styles/SuperAdmin/SATheme.css';
import '../../assets/styles/SuperAdmin/SARoles.css';

const SARoles = ({ SA_ROLES, perms, modCount, selectedRole, setSelectedRole }) => {
    return (
        <div className="animate-in">
            <div style={{ 
                position: 'sticky', 
                top: 0, 
                zIndex: 100, 
                background: 'var(--sa-bg)', 
                paddingBottom: 20,
                marginBottom: 20,
                borderBottom: '1px solid var(--sa-border)'
            }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div>
                        <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, fontFamily: "'Sora'" }}>Role Definitions</h2>
                        <p style={{ margin: "4px 0 0", fontSize: 13, color: "var(--sa-muted)" }}>Define, configure, and manage access roles across all AMSHRMS portals</p>
                    </div>
                </div>
            </div>
            <div className="sa-roles-grid" style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto', paddingRight: 8 }}>
                {SA_ROLES.map(r => {
                    const p = perms[r.id] ? Object.values(perms[r.id]) : [];
                    const full = p.filter(x => x === "full").length, write = p.filter(x => x === "write").length, read = p.filter(x => x === "read").length, none = p.filter(x => x === "none").length;
                    return (
                        <div
                            key={r.id}
                            onClick={() => setSelectedRole(selectedRole === r.id ? null : r.id)}
                            className={`sa-role-card ${selectedRole === r.id ? 'selected' : ''}`}
                            style={{ '--sa-role-color': r.color }}
                        >
                            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
                                <div className="sa-role-icon-box" style={{ background: r.color + "14", border: `2px solid ${r.color}25` }}>{r.icon}</div>
                                <div style={{ flex: 1 }}>
                                    <div style={{ fontSize: 16, fontWeight: 800, fontFamily: "'Sora'", color: r.color }}>{r.name}</div>
                                    <div style={{ fontSize: 11, color: "var(--sa-muted)" }}>{r.users.length} user{r.users.length !== 1 ? "s" : ""} assigned</div>
                                </div>
                                {r.locked && <SABadge color="red">Locked</SABadge>}
                            </div>
                            <div style={{ fontSize: 12, color: "var(--sa-muted)", marginBottom: 16, lineHeight: 1.6 }}>{r.desc}</div>
                            <div style={{ fontSize: 10, color: "var(--sa-dim)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 8 }}>Access Distribution</div>
                            <div className="sa-access-bar">
                                {full > 0 && <div style={{ width: `${(full / modCount) * 100}%`, background: "var(--sa-green)", transition: "width 0.3s" }} />}
                                {write > 0 && <div style={{ width: `${(write / modCount) * 100}%`, background: "var(--sa-orange)" }} />}
                                {read > 0 && <div style={{ width: `${(read / modCount) * 100}%`, background: "var(--sa-blue)" }} />}
                                {none > 0 && <div style={{ width: `${(none / modCount) * 100}%`, background: "var(--sa-border)" }} />}
                            </div>
                            <div style={{ display: "flex", gap: 14, fontSize: 10, color: "var(--sa-muted)" }}>
                                <span><span style={{ color: "var(--sa-green)", fontWeight: 800 }}>{full}</span> Full</span>
                                <span><span style={{ color: "var(--sa-orange)", fontWeight: 800 }}>{write}</span> Write</span>
                                <span><span style={{ color: "var(--sa-blue)", fontWeight: 800 }}>{read}</span> Read</span>
                                <span><span style={{ color: "var(--sa-dim)", fontWeight: 800 }}>{none}</span> None</span>
                            </div>
                            <div style={{ marginTop: 16, borderTop: "1px solid var(--sa-border)", paddingTop: 14 }}>
                                <div style={{ fontSize: 10, color: "var(--sa-dim)", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 10 }}>Assigned Users</div>
                                <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                                    {r.users.map((u, i) => (
                                        <div key={i} className="sa-user-pill">
                                            <div style={{ width: 22, height: 22, borderRadius: 6, background: r.color + "28", color: r.color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, fontWeight: 800 }}>{u.avatar}</div>
                                            <span style={{ fontSize: 11, fontWeight: 600 }}>{u.name}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SARoles;
